import { fetchBlockStatus } from 'api/queries.api'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { useContext } from 'react'
import { SessionContext } from 'contexts/session'
import axios from 'axios'

/**
 * Will use params to load correct station and block status
 * @returns 5 second interval block status
 */
const useBlockStatus = () => {
  const { stationCode, blockIndex } = useParams()
  const { session, setSession } = useContext(SessionContext)
  if (!stationCode || !blockIndex)
    throw new Error(
      'useBlockStatus requires a station and blockId available in the url',
    )
  return useQuery(
    ['blockStatus', stationCode, blockIndex],
    ({ signal }) => {
      // Create a new CancelToken source for this request
      const CancelToken = axios.CancelToken
      const source = CancelToken.source()
      signal?.addEventListener('abort', () => {
        source.cancel('Query was cancelled by TanStack Query')
      })
      return fetchBlockStatus(
        stationCode,
        blockIndex,
        session,
        setSession,
        source,
      )
    },
    { refetchInterval: 5000 },
  )
}

export default useBlockStatus
